import { createSlice } from '@reduxjs/toolkit';
import { fetchSummaryOrder, fetchSummaryAirportTransferOrder, fetchSummaryCustomerOrder } from './actions';
import { checkEmptyObject } from 'utils/functionality';

const initialState = {
  data: {},
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const summaryOrder = createSlice({
  name: 'summaryOrder',
  initialState,
  reducers: {
    // reducers goes here

    resetSummaryData: (state) => {
      state.data = {};
    },
    resetOrderZonePriceData: (state) => {
      if (state.data && !checkEmptyObject(state.data)) {
        state.data.order_zone_price = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummaryOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSummaryOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchSummaryOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSummaryAirportTransferOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSummaryAirportTransferOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchSummaryAirportTransferOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSummaryCustomerOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSummaryCustomerOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchSummaryCustomerOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      });
  },
});

export const { resetSummaryData, resetOrderZonePriceData } = summaryOrder.actions;
export default summaryOrder.reducer;
